import {
  Newsletter,
  NewsletterFragment,
} from '__generated__/queries-newsletter';
import { ResourceType } from 'pages/CampaignPage/CampaignEditPage/ContentPage/utils/useGetBlockItems';
import { WeekDay, weekDays } from 'pages/NewsletterPage/const';
import { clone, isEmpty, omit } from 'ramda';

export const isNewsletterValid = (
  newsletterItem: Newsletter & {
    withAutomation: boolean;
    availableWeekDays: WeekDay[];
  },
) => {
  if (!newsletterItem.brandKey) {
    return 'La marque est obligatoire';
  }
  if (!newsletterItem.name) {
    return 'Le nom est obligatoire';
  }

  // Automation check
  const automationConfigList = JSON.parse(
    newsletterItem.automationConfig || '[]',
  );

  if (automationConfigList.length) {
    if (!newsletterItem.frequency) {
      return 'La fréquence est obligatoire';
    }

    if (!newsletterItem?.availableWeekDays.length) {
      return "Un minimum de un jour est nécessaire pour configurer la fréquence de l'automatisation";
    }

    if (!newsletterItem.automationTime) {
      return "L'heure de création de la campagne est obligatoire";
    }
  }

  const automationConfigListErrors = automationConfigList.map(
    (config: any, i: number) => {
      const titleErrorMessages = `La section ${
        i + 1
      } comporte les erreurs suivantes :`;
      const errorMessagesList = [];

      if (typeof config === 'string') {
        // eslint-disable-next-line fp/no-mutating-methods
        errorMessagesList.push(config);
      }

      if (!config.dayRange && config.type !== ResourceType.EMPTY) {
        // eslint-disable-next-line fp/no-mutating-methods
        errorMessagesList.push('La période de récupération est obligatoire');
      }

      if (!config.type) {
        // eslint-disable-next-line fp/no-mutating-methods
        errorMessagesList.push('Le type de ressource est obligatoire');
      }

      return errorMessagesList.length ? (
        <div style={{ marginBottom: '10px' }} key={i}>
          <strong>{titleErrorMessages}</strong>
          <ul style={{ margin: '2px 0', paddingLeft: '16px' }}>
            {[...errorMessagesList].map((message) => (
              <li key={message}>{message}</li>
            ))}
          </ul>
        </div>
      ) : (
        errorMessagesList
      );
    },
  );

  if (automationConfigListErrors.flat().length) {
    return <div>{automationConfigListErrors}</div>;
  }

  return true;
};

export const transformItem = (item: any) => {
  // eslint-disable-next-line immutable/no-mutation
  item.available = weekDays
    .map((weekDay) =>
      item.availableWeekDays?.find(
        (availableWeekDay: WeekDay) => availableWeekDay.label === weekDay,
      )
        ? '1'
        : '0',
    )
    .join('');

  let mediasToSave = {};
  if (item.medias) {
    mediasToSave = item.medias;
  }

  const itemToSave = clone(item);

  if (!item.automationConfig && !item.automationQuery && !item.automationTime) {
    // eslint-disable-next-line immutable/no-mutation
    itemToSave.available = null;
    // eslint-disable-next-line immutable/no-mutation
    itemToSave.frequency = null;
  }

  // eslint-disable-next-line fp/no-delete
  delete itemToSave._id;
  // eslint-disable-next-line fp/no-delete
  delete itemToSave.availableWeekDays;
  // eslint-disable-next-line fp/no-delete
  delete itemToSave.medias;

  return {
    ...itemToSave,
    rawMedias:
      mediasToSave && !isEmpty(mediasToSave)
        ? JSON.stringify(mediasToSave)
        : null,
  };
};

export const getItemInfoForMutation = (item: NewsletterFragment) => ({
  ...omit(['__typename', 'createdAt', 'updatedAt'], item),
});
